<template>
  <LoadingIcon
    v-if="isLoading"
    :is-loading="isLoading"
    size="lg"
  />

  <div
    class="support-faq-items"
    v-else
  >
    <section
      v-for="supportFAQCategory in supportFAQCollection"
      :key="supportFAQCategory.category"
    >
      <h2
        class="support-faq-item-title mb-3"
      >{{ supportFAQCategory.category }}</h2>

      <SupportFAQItem
        v-for="supportFAQ in supportFAQCategory.items"
        :key="supportFAQ.slug"
        :ref="supportFAQ.slug"
        class="support-faq-item"
        :faq="supportFAQ"
      />
    </section>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import SupportFAQItem from './SupportFAQItem'
  import PrimaryTitle from '@/components/text/titles/PrimaryTitle'
  import LoadingIcon from '@/components/layout/LoadingIcon'

  export default {
    components: {
      SupportFAQItem,
      PrimaryTitle,
      LoadingIcon,
    },

    data: () => ({
      isLoading: true
    }),

    async mounted () {
      this.isLoading = true

      if (!this.supportFAQCollection.length) {
        await this.fetchSupportFAQCollection()
      }

      this.isLoading = false

      setTimeout(() => window.location.hash.split('#')[1] && this.scrollToFAQItem(window.location.hash.split('#')[1]), 1000)
    },

    computed: {
      ...mapGetters('support', ['supportFAQCollection'])
    },

    methods: {
      ...mapActions('support', ['fetchSupportFAQCollection']),

      scrollToFAQItem (slug) {
        const faqItem = document.getElementById(slug)

        if (faqItem) {
          faqItem.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          })

          this.$refs[slug][0].toggle()
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  .support-faq-items section {
    &:not(:last-child) {
      margin-bottom: 40px;
    }

    .support-faq-item:not(:last-child) {
      margin-bottom: 20px;
    }

    .support-faq-item-title {
      font-size: 1rem;
      color: $highlightPrimaryColor;
    }
  }
</style>